module.exports = __webpack_public_path__ + "static/TW_-11cfbdf88598b580b4a556c8479c2e62.png";